/** Question paper PDF tokens aligned with QuestionPaperStudentSheet UI. */
export const questionPaperPdfTheme = {
  primary: "#F19500",
  primaryDark: "#9A3412",
  primaryMuted: "#78350F",
  primarySoft: "#FFF9EE",
  sectionBg: "#FFFBEB",
  pageBg: "#FFFDF8",
  border: "#FDE68A",
  cardBorder: "#E5E7EB",
  questionBadge: "#1F2937",
  instructionsText: "#431407",
  text: "#111827",
  muted: "#64748B",
  white: "#FFFFFF",
  answerLine: "#CBD5E1",
};

export const questionPaperPdfLayout = {
  marginX: 12,
  contentTop: 10,
  contentBottom: 276,
  lineHeight: 5,
  sectionGap: 5,
  questionGap: 5,
  cardPadding: 4,
  optionGap: 3,
  headerHeight: 52,
  sectionHeaderHeight: 16,
  questionNumberSize: 8,
  optionCircleSize: 5,
  answerBubbleSpacing: 12,
  answerNumberColumnWidth: 16,
  studentMcqAnswerRowHeight: 14,
};

export function getQuestionPaperContentWidth(pageWidth = 210) {
  return pageWidth - questionPaperPdfLayout.marginX * 2;
}
